import { render } from "./TreeWithSidePopup.vue?vue&type=template&id=22ea3eb0&scoped=true"
import script from "./TreeWithSidePopup.js?vue&type=script&lang=js"
export * from "./TreeWithSidePopup.js?vue&type=script&lang=js"

import "./TreeWithSidePopup.vue?vue&type=style&index=0&id=22ea3eb0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ea3eb0"]])

export default __exports__